import DialogWalletRuleField from './DialogWalletRuleField';

// An allowance rule reads the create alone, so its note leaves out the wallet
// counters' _2 and [start+count]. The examples are the language itself, never translated.
const SYNTAX = [
    ['walletRules.syntax.if', 'if ($request_amount%d >= 10000%d & $request_amount%d <= 5000000%d) { true } else { false }'],
    ['walletRules.syntax.allowance'],
    ['walletRules.syntax.operators'],
    ['walletRules.syntax.whitespace'],
    ['walletRules.syntax.case']
];

/**
 * A gateway rule's rule — a gateway's payin or payout allowance rule, which core
 * reads once per create, before any wallet is chosen: the BigText editor and the
 * language's help, as a wallet rule's, with the variables GatewayRulesPage loads
 * into the store (only the create's own: its amount, the time, the terminal's
 * currency, the payin's p2p method).
 *
 * The cabinet compiles the rule on save and refuses one that does not compile, or
 * reads a wallet (422 `GATEWAY_RULE_INVALID: …`); the dialog shows that as any
 * other refusal.
 */
export default class DialogGatewayRuleField extends DialogWalletRuleField {
    static variablesKey = 'gatewayRuleVariables';

    syntax() {
        return SYNTAX;
    }
}
